<template>
  <div :style="`min-width:${barChartTotal.chartData.labels.length * 8}px;max-width:100%;`">
    <bar-chart :height="height" :chart-data="barChartTotal.chartData"
      :extra-options="barChartTotal.extraOptions"></bar-chart>
  </div>
</template>

<script>
import moment from "moment"
import BarChart from '@/components/Charts/BarChart'
import { mapActions, mapGetters } from 'vuex'
import defaultChartObjects from "../defaultChartObjects"

export default {
  component: 'BarChartVisitantes',

  components: {
    BarChart,
  },

  props: {
    height: {
      type: Number,
      default: 250
    },

    fetchProgress: {
      type: Number,
      default: 0 | 100
    },

    colors: {
      type: Array,
      default: []
    },

    endDate: {
      type: String,
      default: "",
    },

    chartTotalView: {
      type: String,
      default: "day",
    },

    defaultBarThickness: {
        type: Number,
        default: 8,
    },

    maxBarThickness: {
        type: Number,
        default: 30,
    },

    clientsCountItemName: {
      type: String,
      default: "itens",
    },

    todayReferenceDate: {
      type: String,
      default: "",
    },

    filteredDataCharts: {
      type: Array | Object,
      default: [] | {},
    },
  },

  methods: {
    ...mapActions('product',[
      "productStoreCommit",
    ]),

    //METHOD TO GROUP BY KEYGETTER.
    //KEYGETTER MUST BE "foo => foo.fieldYouWantToGroupBy"
    groupBy(list, keyGetter) {
      const map = new Map();
      list.forEach((item) => {
        const key = keyGetter(item);
        const collection = map.get(key);
        if (!collection) { map.set(key, [item]); }
        else { collection.push(item); }
      });
      return Array.from(map);
    },
  },

  data: () => {
    return {
    }
  },

  computed: {
    ...mapGetters('product', {
      useChartCache: "getUseChartCache",
      cacheObject: "getBarChartVisitantes",
    }),

    monthNamesAbr() { return ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'] },

    barChartTotal() {
      var defaultChart = JSON.parse(JSON.stringify(defaultChartObjects.defaultBarChartVisitantes))
      let chartInfo = this.groupBy([], val => moment(val.data).format('YYYY-MM-DD'))

      if (this.useChartCache == true && this.fetchProgress != 100 && this.cacheObject != undefined && this.cacheObject.length > 0) {
        chartInfo = JSON.parse(JSON.stringify(this.cacheObject))
      }else{
        chartInfo = this.groupBy(this.filteredDataCharts.filter(function (val, idx) { return val.status == 'APPROVED' }), val => {
          var date = val.data ? val.data : val.datePaid
          return moment(date).format('YYYY-MM-DD')
        })         //DATA OF CHART
      }

      if(this.fetchProgress < 100){
        sessionStorage.removeItem('SET_BAR_CHART_VISITANTES_save')
      }

      if (this.useChartCache == true && this.fetchProgress == 100 && !sessionStorage.getItem('SET_BAR_CHART_VISITANTES_save')) {
        sessionStorage.setItem('SET_BAR_CHART_VISITANTES_save','true')
        this.productStoreCommit({ mutation: "SET_BAR_CHART_VISITANTES", value: JSON.parse(JSON.stringify(chartInfo)) })
      }

      let vm = this
      let weekendDaysNumbers = { 0: 'sat', 6: 'sun' }
      let weekendDaysColor = '#1D889C'
      let barColors = '#002C3B'
      let lineColors = '#fd5959'
      let labels = []    //LABELS OF CHART
      let amountLabel = this.clientsCountItemName //Label for charts amount
      let weekdayLabels = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']

      Date.prototype.getWeek = function () {
        var onejan = new Date(this.getFullYear(), 0, 1);
        return Math.ceil((((this - onejan) / 86400000) + onejan.getDay() + 1) / 7);
      }

      if (this.chartTotalView == 'semester') {
        var semestersDefault = ['1º Semestre', '2º Semestre']

        // Creating array of dates => ["1º Semestre/2022", "1º Semestre/2023", "2º Semestre/2022"  ....]
        var existingSemesters = chartInfo.map(function (value, index) {
          var sName = new Date(value[0]).getMonth() >= 6 ? 1 : 0
          return semestersDefault[sName] + "/" + new Date(value[0]).getFullYear()
        })

        labels = [... new Set(existingSemesters)]                                           // REMOVING Duplicates
        labels.sort(function (a, b) {
          const [semestreA, anoA] = a.split("/");
          const [semestreB, anoB] = b.split("/");
          const numeroSemestreA = parseInt(semestreA, 10);
          const numeroSemestreB = parseInt(semestreB, 10);
          return anoA - anoB || numeroSemestreA - numeroSemestreB;
        })

        barColors = new Array(labels.length).fill(barColors)
        lineColors = new Array(labels.length).fill(lineColors)
        var chartInfoArray = new Array(labels.length).fill(0)
        var chartValor = new Array(labels.length).fill(0)
        var chartTrafx = new Array(labels.length).fill(0)
        var chartFinance = new Array(labels.length).fill(0)

        // GETTING AMOUNT OF VISITORS BY SEMESTER
        chartInfo.map(function (val, idx) {
          var semester = new Date(val[0]).getMonth() >= 6 ? 1 : 0;                                    // Getting semester name based on semester number (0 => 1º, 1 => 2º, ...)
          var semesterName = semestersDefault[semester] + "/" + new Date(val[0]).getFullYear()        // Modeling to format Nº Semester/Year
          var semesterIndex = labels.findIndex(i => i == semesterName)                                // Finding index from current semester on labels array

          val[1].map(function (v, i) {
            var people_count = v.people.tableText.count

            if (v.trafx) { chartTrafx[semesterIndex] += people_count }
            if(v.finance){ chartFinance[semesterIndex] += people_count }
            else {
              var sdate = moment(v.sdate * 1000)
              var datePaid = v.datePaid.split(' ')[0]
              var size = people_count / 1
              chartInfoArray[semesterIndex] += size
              chartTrafx[semesterIndex] += 0
              chartFinance[semesterIndex] += 0

              if (sdate.format('YYYY-MM-DD') != datePaid) { chartValor[semesterIndex] += size }
              else { chartValor[semesterIndex] += 0 }
            }
          })
        })
        chartInfo = chartInfoArray;
      }

      else if (this.chartTotalView == 'month') {
        // Creating array of dates => ["Dez/2022", "Jan/2023", ....]
        var existingMonths = chartInfo.map(function (value, index) {
          var mName = vm.monthNamesAbr[new Date(value[0]).getMonth()]
          return mName + "/" + new Date(value[0]).getFullYear()
        })

        labels = [... new Set(existingMonths)]      // REMOVING Duplicates
        labels = labels.sort(function (a, b) {
          const [mesA, anoA] = a.split("/");
          const [mesB, anoB] = b.split("/");
          const indexA = vm.monthNamesAbr.indexOf(mesA);
          const indexB = vm.monthNamesAbr.indexOf(mesB);
          const dataA = new Date(anoA, indexA, 1);
          const dataB = new Date(anoB, indexB, 1);
          return dataA - dataB;
        })

        barColors = new Array(labels.length).fill(barColors)
        lineColors = new Array(labels.length).fill(lineColors)
        var chartInfoArray = new Array(labels.length).fill(0)
        var chartValor = new Array(labels.length).fill(0)
        var chartTrafx = new Array(labels.length).fill(0)
        var chartFinance = new Array(labels.length).fill(0)

        // GETTING AMOUNT OF VISITORS BY MONTH
        chartInfo.map(function (val, idx) {
          var monthName = vm.monthNamesAbr[new Date(val[0]).getMonth()]           // Getting month name based on month number (0 => jan, 1 => fev, ...)
          var month = (monthName) + "/" + new Date(val[0]).getFullYear();         // Modeling to format Month/Year
          var monthIndex = labels.findIndex(i => i == month)                      // Finding index from current month on labels array

          val[1].map(function (v, i) {
            var people_count = v.people.tableText.count

            if (v.trafx) { chartTrafx[monthIndex] += people_count }
            if(v.finance){ chartFinance[monthIndex] += people_count }
            else {
              var sdate = moment(v.sdate * 1000)
              var datePaid = v.datePaid.split(' ')[0]
              var peopleCount = people_count / 1
              chartInfoArray[monthIndex] += peopleCount
              chartTrafx[monthIndex] += 0
              chartFinance[monthIndex] += 0

              if (sdate.format('YYYY-MM-DD') != datePaid) { chartValor[monthIndex] += peopleCount }
              else { chartValor[monthIndex] += 0 }
            }
          })
        })
        chartInfo = chartInfoArray;
      }

      else if (this.chartTotalView == 'week') {
        // Creating array of dates => ["1ª sem/2022", "2ª sem/2022", ....]
        var existingWeeks = chartInfo.map(function (value, index) {
          var date = moment(value[0])
          return moment(date).week() + "ª sem/" + date.year();
        })

        labels = [... new Set(existingWeeks)]     // REMOVING Duplicates and SORTING
        labels = labels.sort(function (a, b) {
          const [semanaA, anoA] = a.split(" sem/");
          const [semanaB, anoB] = b.split(" sem/");
          const numeroSemanaA = parseInt(semanaA, 10);
          const numeroSemanaB = parseInt(semanaB, 10);
          return anoA - anoB || numeroSemanaA - numeroSemanaB;
        })

        barColors = new Array(labels.length).fill(barColors)
        lineColors = new Array(labels.length).fill(lineColors)
        var chartInfoArray = new Array(labels.length).fill(0)
        var chartValor = new Array(labels.length).fill(0)
        var chartTrafx = new Array(labels.length).fill(0)
        var chartFinance = new Array(labels.length).fill(0)

        // GETTING AMOUNT OF VISITORS BY WEEK
        chartInfo.map(function (val, idx) {
          var week = moment(val[0]).week()                                           // Getting week name based on week number (0 => 1ª sem, 1 => 2ª sem, ...)
          var weekName = week + "ª sem/" + moment(val[0]).year();                // Modeling to format Nª week/YEAR
          var weekIndex = labels.findIndex(i => i == weekName)                            // Finding index from current week on labels array

          val[1].map(function (v, i) {
            var people_count = v.people.tableText.count

            if (v.trafx) { chartTrafx[weekIndex] += people_count }
            if(v.finance){ chartFinance[weekIndex] += people_count }
            else {
              var sdate = moment(v.sdate * 1000)
              var datePaid = v.datePaid.split(' ')[0]
              var peopleCount = people_count / 1
              chartInfoArray[weekIndex] += peopleCount
              chartTrafx[weekIndex] += 0
              chartFinance[weekIndex] += 0

              if (sdate.format('YYYY-MM-DD') != datePaid) { chartValor[weekIndex] += peopleCount }
              else { chartValor[weekIndex] += 0 }
            }
          })
        })

        var today = moment()
        var currentweek = today.week() + "ª sem/" + today.year();

        labels.map(function (val, idx) {
          const data1SemAcento = val.replace('ª', '');
          const data2SemAcento = currentweek.replace('ª', '');
          const momentData1 = moment(data1SemAcento, 'W [sem/]YYYY');
          const momentData2 = moment(data2SemAcento, 'W [sem/]YYYY');
          if (!momentData1.isBefore(momentData2)) { barColors[idx] = 'grey' }
        })
        chartInfo = chartInfoArray;
      }

      else if (this.chartTotalView == 'day') {
        labels = chartInfo.map(function (val, idx) { return val[0] })
        labels.push(this.endDate)
        labels.sort();

        var labelsClone = labels
        const completeDates = new Set(labelsClone);

        labelsClone.reduce((prevDate, currDate) => {
          const startDate = moment(prevDate);
          const endDate = moment(currDate);
          const daysDiff = endDate.diff(startDate, "days");

          // Adiciona todas as datas intermediarias
          Array.from({ length: daysDiff - 1 }, (_, index) => {
            completeDates.add(startDate.clone().add(index + 1, "days").format("YYYY-MM-DD"));
          });

          return currDate;
        });

        labels = Array.from(completeDates).sort((a, b) => moment(a).diff(moment(b)));

        barColors = new Array(labels.length).fill(barColors)
        lineColors = new Array(labels.length).fill(lineColors)
        var chartInfoArray = new Array(labels.length).fill(0)
        var chartValor = new Array(labels.length).fill(0)
        var chartTrafx = new Array(labels.length).fill(0)
        var chartFinance = new Array(labels.length).fill(0)
        let _todayReferenceDate = this.todayReferenceDate

        // GETTING AMOUNT OF VISITORS BY DATE
        chartInfo.map(function (val, idx) {
          var day = moment(val[0]).format('YYYY-MM-DD')
          var dayIndex = labels.indexOf(day)

          val[1].map(function (v, i) {
            var people_count = v.people.tableText.count

            if (v.trafx) { chartTrafx[dayIndex] += people_count }
            if(v.finance){ chartFinance[dayIndex] += people_count }
            else {
              var sdate = moment(v.sdate * 1000)
              var datePaid = v.datePaid.split(' ')[0]
              var peopleCount = people_count / 1
              chartInfoArray[dayIndex] += peopleCount
              chartTrafx[dayIndex] += 0
              chartFinance[dayIndex] += 0

              if (sdate.format('YYYY-MM-DD') != datePaid) { chartValor[dayIndex] += peopleCount }
              else { chartValor[dayIndex] += 0 }
            }
          })
        })

        labels = labels.map(function (val, idx) {
          var date = moment(val, 'YYYY-MM-DD')
          if (date.diff(moment(_todayReferenceDate)) > 0) { barColors[idx] = 'grey' }

          //sat or sunday
          if (weekendDaysNumbers[date.day()]) { barColors[idx] = weekendDaysColor }
          return date.format('DD/MM/YY') + ' (' + weekdayLabels[date.day()] + ')'
        })
        chartInfo = chartInfoArray;
      }

      else if (this.chartTotalView == 'weekday') {
        labels = weekdayLabels

        barColors = new Array(labels.length).fill(barColors)
        lineColors = new Array(labels.length).fill(lineColors)
        var chartInfoArray = new Array(labels.length).fill(0)
        var chartValor = new Array(labels.length).fill(0)
        var chartTrafx = new Array(labels.length).fill(0)
        var chartFinance = new Array(labels.length).fill(0)

        // GETTING AMOUNT OF VISITORS BY DAY OF A WEEK
        chartInfo.map(function (val, idx) {
          var weekday = moment(val, 'YYYY-MM-DD').day()

          val[1].map(function (v, i) {
            var people_count = v.people.tableText.count

            if (v.trafx) { chartTrafx[weekday] += people_count }
            if(v.finance){ chartFinance[weekday] += people_count }
            else {
              var sdate = moment(v.sdate * 1000)
              var datePaid = v.datePaid.split(' ')[0]
              var peopleCount = people_count / 1
              chartInfoArray[weekday] += peopleCount
              chartTrafx[weekday] += 0
              chartFinance[weekday] += 0

              if (sdate.format('YYYY-MM-DD') != datePaid) { chartValor[weekday] += peopleCount }
              else { chartValor[weekday] += 0 }
            }
          })

          //sat or sunday
          if (weekendDaysNumbers[weekday]) { barColors[weekday] = weekendDaysColor }
        })
        chartInfo = chartInfoArray;
      }

      chartValor = chartValor.reduce((prev, curr) => prev + curr, 0) > 0 ? chartValor : []

      defaultChart.chartData = {
        labels: labels,      //NOMES DOS LABELS DO PERIODO
        datasets: [
          {
            label: `Qtd. ${amountLabel}`,
            yAxisID: 'A',
            data: chartInfo,               //VALOR DA QNTD DE VISITANTE POR PERIODO
            backgroundColor: barColors,
            barThickness: this.defaultBarThickness,
            maxBarThickness: this.maxBarThickness,
          },
          {
            label: 'Agendados',
            yAxisID: 'A',
            data: chartValor,
            backgroundColor: 'transparent',
            borderColor: '#AAF098',
            type: 'line',
          },
          {
            label: 'Trafx',
            yAxisID: 'A',
            data: chartTrafx,
            backgroundColor: 'transparent',
            borderColor: '#0D6A88',
            type: 'line',
          },
          {
            label: 'Entradas Financeiras',
            yAxisID: 'A',
            data: chartFinance,
            backgroundColor: 'transparent',
            borderColor: '#2C46D3',
            type: 'line',
          },
        ],
      }

      defaultChart.extraOptions = {
        legend: { display: false, },
        animation: false,
          transitions: {
              ative: {
                  animation: {
                      duration: 0,
                  }
              }
          },
        tooltips: {
          callbacks: {
            label: function (tooltipItem) {
              if (tooltipItem.datasetIndex == 0) { return `${Number(tooltipItem.value)} ${amountLabel}` }
              else if (tooltipItem.datasetIndex == 1) { return `${Number(tooltipItem.value)} Vendas antecipadas` }
              else if (tooltipItem.datasetIndex == 2 && tooltipItem.value > 0) { return `${Number(tooltipItem.value)} Registros Trafx` }
              else if (tooltipItem.datasetIndex == 3) { return `${Number(tooltipItem.value)} Entradas Financeiras` }
            }
          }
        },
        scales: {
          yAxes: [
            {
              id: 'A',
              type: 'linear',
              position: 'left',
              title: 'Quantidade Visitantes',
              barPercentage: 0.3,
            },
          ],
        },
      }

      return defaultChart
    },
  },
}


</script>
